import { FC } from 'react'
import styled from 'styled-components'

export type Props = {
  property: string | React.ReactElement
  value: string | React.ReactElement
}

export const DottedPropertyValue: FC<Props> = ({ property, value }) => {
  return (
    <>
      <PropertyWrapper>
        <Property>{property}</Property>
      </PropertyWrapper>
      <Value>{value}</Value>
    </>
  )
}

const PropertyWrapper = styled.div`
  position: relative;
  flex-grow: 1;
  margin: 0;
  padding-right: ${({ theme }) => theme.spacing[1]};

  &:before {
    content: '';
    position: absolute;
    bottom: 6px;
    left: 0;
    z-index: 0;
    display: block;
    width: 100%;
    border-bottom: ${({ theme }) => `1px dotted ${theme.palette.grey[500]}`};
  }
`

const Property = styled.span`
  padding-right: 5px;
  position: relative;
  background: ${({ theme }) => theme.palette.white};
`

const Value = styled.div`
  margin: auto 0 0 0;
  padding-left: ${({ theme }) => theme.spacing[1]};
  background: ${({ theme }) => theme.palette.white};
  text-align: right;
  max-width: 65%;
`
